import React from 'react';

const LogActionButtons = ({ 
    item, 
    isDark, 
    postalDocUrl, 
    onOpenEmailPopup, 
    onOpenSmsPopup, 
    onOpenPostalPopup 
}) => {
    return (
        <div className="flex flex-row items-center gap-[6px]">
            {item["Log Type"] === 'email' && (
            <button
                onClick={() => onOpenEmailPopup(item)}
                className={`rounded-[10px] px-[8px] sm:px-[10px] py-[6px] flex items-center gap-[6px] border-0 cursor-pointer transition-colors whitespace-nowrap ${
                isDark
                    ? 'bg-[#f5f5f5] text-[#000000] border border-[#292929] hover:bg-[#e8e8e8]'
                    : 'bg-[#072837] text-white hover:bg-[#0a3a4d]'
                }`}
            >
                <div
                className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]"
                style={{
                    backgroundColor: isDark ? '#000000' : '#ffffff',
                    WebkitMaskImage: "url('/assets/icons/viewdata.svg')",
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskSize: 'contain',
                    WebkitMaskPosition: 'center',
                    maskImage: "url('/assets/icons/viewdata.svg')",
                    maskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    maskPosition: 'center',
                    transition: 'background-color 0.2s ease'
                }}
                aria-hidden="true"
                />
                <span className="font-medium text-[14px] sm:text-[16px] transition-colors duration-200">View</span>
            </button>
            )}
            {item["Log Type"] === 'email' && item["conversationId"] && (
            <a
                href={`https://app.frontapp.com/open/${item["conversationId"]}`}
                target="_blank"
                rel="noopener noreferrer"
                className={`rounded-[10px] px-[10px] sm:px-[12px] py-[6px] flex items-center gap-[6px] border-0 cursor-pointer transition-colors whitespace-nowrap no-underline bg-[#cd6d2c] ${isDark ? 'hover:bg-white' : 'hover:bg-[#072837]'}`}
            >
                <div
                className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]"
                style={{
                    backgroundColor: isDark ? '#161515' : '#ffffff',
                    WebkitMaskImage: "url('/assets/icons/front.svg')",
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskSize: 'contain',
                    WebkitMaskPosition: 'center',
                    maskImage: "url('/assets/icons/front.svg')",
                    maskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    maskPosition: 'center',
                    transition: 'background-color 0.2s ease'
                }}
                aria-hidden="true"
                />
                <span className={`font-semibold text-[14px] sm:text-[16px] transition-colors duration-200 ${isDark ? 'text-[#161515]' : 'text-white'}`}>Open in Front</span>
            </a>
            )}
            {item["Log Type"] === 'sms' && item["Sending Text"] && (
            <button
                onClick={() => onOpenSmsPopup(item)}
                className={`rounded-[10px] px-[8px] sm:px-[10px] py-[6px] flex items-center gap-[6px] border-0 cursor-pointer transition-colors whitespace-nowrap ${
                isDark
                    ? 'bg-[#f5f5f5] text-[#000000] border border-[#292929] hover:bg-[#e8e8e8]'
                    : 'bg-[#072837] text-white hover:bg-[#0a3a4d]'
                }`}
            >
                <div
                className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]"
                style={{
                    backgroundColor: isDark ? '#000000' : '#ffffff',
                    WebkitMaskImage: "url('/assets/icons/viewdata.svg')",
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskSize: 'contain',
                    WebkitMaskPosition: 'center',
                    maskImage: "url('/assets/icons/viewdata.svg')",
                    maskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    maskPosition: 'center',
                    transition: 'background-color 0.2s ease'
                }}
                aria-hidden="true"
                />
                <span className="font-medium text-[14px] sm:text-[16px] transition-colors duration-200">View</span>
            </button>
            )}
            {item["Log Type"] === 'postal' && item["Message"] === 'Successfully uploaded to bingmail' && postalDocUrl && (
            <button
                onClick={() => onOpenPostalPopup(item)}
                className={`rounded-[10px] px-[8px] sm:px-[10px] py-[6px] flex items-center gap-[6px] border-0 cursor-pointer transition-colors whitespace-nowrap ${
                isDark
                    ? 'bg-[#f5f5f5] text-[#000000] border border-[#292929] hover:bg-[#e8e8e8]'
                    : 'bg-[#072837] text-white hover:bg-[#0a3a4d]'
                }`}
            >
                <div
                className="w-[14px] h-[14px] sm:w-[16px] sm:h-[16px]"
                style={{
                    backgroundColor: isDark ? '#000000' : '#ffffff',
                    WebkitMaskImage: "url('/assets/icons/viewdata.svg')",
                    WebkitMaskRepeat: 'no-repeat',
                    WebkitMaskSize: 'contain',
                    WebkitMaskPosition: 'center',
                    maskImage: "url('/assets/icons/viewdata.svg')",
                    maskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    maskPosition: 'center',
                    transition: 'background-color 0.2s ease'
                }}
                aria-hidden="true"
                />
                <span className="font-medium text-[14px] sm:text-[16px] transition-colors duration-200">View</span>
            </button>
            )}
        </div>
    );
};

export default LogActionButtons;
